import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const PublicationGuideSmallCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.8rem;
  border: 2px dashed ${({ theme }) => theme.colors.bluePrimary};
  padding: 2.5rem 3.5rem;
  background-color: ${({ theme }) => theme.colors.blueBack};
`

export const Wrapper = styled.div``

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSansXlBold};
  margin: 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-top: 0.5rem;
`

export const Button = styled(ActionButton)`
  width: 30.2rem;
`
